<template>
  <div class="d-flex">
    <v-menu offset-y>
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn width="140" depressed outlined text v-bind="attrs" v-on="{ ...tooltip, ...menu }">
              <span class="subtitle-2">{{ current_planner_group }}</span>
            </v-btn>
          </template>
          <span>Planner Group</span>
        </v-tooltip>
      </template>
      <v-list dense>
        <v-list-item-group mandatory color="primary">
          <v-list-item v-for="item in items" :key="item" @click="updatePlannerGroup(item)">
            <v-list-item-title class="subtitle-2">{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "PlannerGroupPicker",
  props: {
    current_planner_group: String,
    items: Array,
    is_loading: Boolean,
  },
  data: function () {
    return {
      selected_group: null,
      groups: [],
    };
  },
  methods: {
    updatePlannerGroup(group) {
      this.$emit("updatePlannerGroup", group);
    },
  },
};
</script>
